import type React from 'react';
import InfoTooltip from '~/components2/InfoTooltip';

interface Props {
  children: React.ReactNode;
  tooltip?: string;
  /** Test id for the heading's help trigger. */
  tooltipTestId?: string;
}

export function MajorHeading({ children, tooltip, tooltipTestId }: Props) {
  return (
    <div className="flex items-center gap-2 text-sm font-bold">
      {children}
      {tooltip && (
        <InfoTooltip
          text={tooltip}
          label={typeof children === 'string' ? `About ${children}` : 'More information'}
          testId={tooltipTestId}
        />
      )}
    </div>
  );
}
